// Modules:
import React from 'react';
import Drawer from '@mui/material/Drawer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

// Components:
import LegendItems from '../Map/LegendItems';

const LAYER_TITLE_LENGTH_LIMIT = 30; // Around 30 chars is when there are overflow issues for a layer title.

const MobileDrawer = ({
    showDrawer,
    handleDrawerClose,
    layers,
    activeLayers,
    pathname,
    determineClassName,
    determineParams,
    routeToLayers,
}) => (
    <Drawer open={showDrawer} onClose={handleDrawerClose}>
        <div className="mobile-drawer-min-content-container">
            <div className="mobile-drawer-header-container">
                <div className="mobile-drawer-header-content">
                    Manage Additional Layers
                    <CloseIcon
                        onClick={handleDrawerClose}
                        className="mobile-drawer-close-icon-container"
                    />
                </div>
            </div>
            <div className="mobile-drawer-detail-content-container">
                {layers
                    .filter(
                        (layer) =>
                            layer.toggleable &&
                            layer.renderInfo?.type !== 'simple'
                    )
                    .map((layer) => {
                        const layerOn = activeLayers.includes(layer.id);
                        return (
                            <div
                                className="legend-list-checkbox-item"
                                key={layer.id}
                            >
                                <Link
                                    to={`${pathname}${determineParams()}layers=${routeToLayers(
                                        layer.id,
                                        layerOn
                                    )}`}
                                    value={layer.id}
                                    key={layer.id}
                                    className="toggle-card-links"
                                >
                                    <div
                                        className={`mobile-${determineClassName(
                                            !layer.toggleable,
                                            layerOn,
                                            layer.renderInfo?.type
                                        )}`}
                                    >
                                        <div className="detail-content-layer-icon-and-title">
                                            <div className="mobile-detail-eye-container">
                                                {activeLayers.includes(
                                                    layer.id
                                                ) ? (
                                                    <VisibilityIcon />
                                                ) : (
                                                    <VisibilityOffIcon />
                                                )}
                                            </div>
                                            <div
                                                // Applies a font-size decrease and wrapping logic only to lengthy layer titles.
                                                className={`detail-content-layer-title${
                                                    layer.title.length >=
                                                    LAYER_TITLE_LENGTH_LIMIT
                                                        ? '-compress'
                                                        : ''
                                                }`}
                                            >
                                                {layer.title}
                                            </div>
                                        </div>
                                        <div className="detail-content-legend-items-container">
                                            {layer.renderInfo ? (
                                                <LegendItems
                                                    layer={layer}
                                                    layerOn={layerOn}
                                                />
                                            ) : null}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        );
                    })}
            </div>
            {layers
                .filter(
                    (layer) =>
                        layer.toggleable &&
                        layer.renderInfo?.type !== 'classBreaks'
                )
                .map((layer) => {
                    const layerOn = activeLayers.includes(layer.id);
                    return (
                        <div
                            className="legend-list-checkbox-item"
                            key={layer.id}
                        >
                            <Link
                                to={`${pathname}${determineParams()}layers=${routeToLayers(
                                    layer.id,
                                    layerOn
                                )}`}
                                value={layer.id}
                                key={layer.id}
                                className="toggle-card-links"
                            >
                                <div
                                    className={determineClassName(
                                        !layer.toggleable,
                                        layerOn,
                                        layer.renderInfo?.type
                                    )}
                                >
                                    <div className="min-content-legend-items-container">
                                        {layer.renderInfo ? (
                                            <LegendItems
                                                layer={layer}
                                                layerOn={layerOn}
                                            />
                                        ) : null}
                                    </div>
                                    <div className="mobile-drawer-title-visibility-container">
                                        <div className="min-content-eye-container">
                                            {activeLayers.includes(layer.id) ? (
                                                <VisibilityIcon />
                                            ) : (
                                                <VisibilityOffIcon />
                                            )}
                                        </div>
                                        <div className="min-content-layer-title">
                                            {layer.title}
                                        </div>
                                        <div className="mobile-min-content-layer-subtitle">
                                            {`${layer.subtitle} ${
                                                layer.layerYear
                                                    ? ` (${layer.layerYear})`
                                                    : ''
                                            }`}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    );
                })}
        </div>
    </Drawer>
);

export default MobileDrawer;
